<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="setting">
        <p>Settings</p>
        <div class="setting__nav">
          <div
            class="setting__nav--item"
            v-bind:style="[
              userManagement
                ? { color: '#5099de', borderBottom: '5px solid #5099de' }
                : { color: '#c7c7c7', borderBottom: '5px solid transparent' },
            ]"
            @click="openUserManagement"
          >
            User Management
          </div>
          <div
            class="setting__nav--item"
            v-bind:style="[
              payrollSetting
                ? { color: '#5099de', borderBottom: '5px solid #5099de' }
                : { color: '#c7c7c7', borderBottom: '5px solid transparent' },
            ]"
            @click="openPayrollSetting"
          >
            Payroll Settings
          </div>

          <div
            class="setting__nav--item"
            v-bind:style="[
              companySetting
                ? { color: '#5099de', borderBottom: '5px solid #5099de' }
                : { color: '#c7c7c7', borderBottom: '5px solid transparent' },
            ]"
            @click="openCompanySetting"
          >
            Company Settings
          </div>
          <div
            class="setting__nav--item"
            v-bind:style="[
              apiKeys
                ? { color: '#5099de', borderBottom: '5px solid #5099de' }
                : { color: '#c7c7c7', borderBottom: '5px solid transparent' },
            ]"
            @click="openApiKeys"
          >
            Api Keys
          </div>
        </div>
        <div v-if="manager !== 1">
          <div class="f_content"  v-if="userManagement">
            <UserManagement />
          </div>
          <div v-if="payrollSetting">
            <PayrollSetting />
          </div>

          <div v-if="companySetting" id="departments">
            <CompanySetting />
          </div>
          <div v-if="apiKeys">
            <ApiKeys />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import CompanySetting from "./companySetting";
import PayrollSetting from "./payrollSetting";
import UserManagement from "./userManagement";
import ApiKeys from "./apiKeys";

export default {
  name: "Setting",
  components: {
    Header,
    Sidebar,
    CompanySetting,
    PayrollSetting,
    UserManagement,
    ApiKeys,
  },
  data() {
    return {
      item: "setting",
      userManagement: true,
      payrollSetting: false,
      companySetting: false,
      apiKeys: false,
      manager: 1,
    };
  },
  metaInfo: {
    title: ' Company Settings - Customize Your HR Desk Experience',
    meta: [
      { name: 'description', content: ' Tailor HR Desk to your company’s needs with customizable settings. Manage company information, configure payroll services, and optimize your HR system.' },
      { property: 'og:title', content: ' Company Settings - Customize Your HR Desk Experience' },
      { property: 'og:description', content: ' Tailor HR Desk to your company’s needs with customizable settings. Manage company information, configure payroll services, and optimize your HR system.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/settings' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: ' Company Settings - Customize Your HR Desk Experience' },
      { name: 'twitter:description', content: ' Tailor HR Desk to your company’s needs with customizable settings. Manage company information, configure payroll services, and optimize your HR system.' },
      { name: 'twitter:image:alt', content: 'Settings at hrdesk' },
      { name: 'keywords', content: 'company settings, HR customization, HR policies, company information management, HR system configuration' },
    ]
  },
  methods: {
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId =
          this.$store.getters.currentAuthUser.employees.company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }
    },
    openUserManagement() {
      this.userManagement = true;
      this.payrollSetting = false;
      this.companySetting = false;
      this.apiKeys = false;
    },
    openPayrollSetting() {
      this.userManagement = false;
      this.payrollSetting = true;
      this.companySetting = false;
      this.apiKeys = false;
    },

    openCompanySetting() {
      this.userManagement = false;
      this.payrollSetting = false;
      this.companySetting = true;
      this.apiKeys = false;
    },
    openApiKeys() {
      this.apiKeys = true;
      this.userManagement = false;
      this.payrollSetting = false;
      this.companySetting = false;
    },
  },
  mounted() {
    if (this.$store.showCompanySetting) {
      let location = this.$store.showCompanySetting;

      if (location == "company") {
        this.openCompanySetting();
      } else if (location === "payroll") {
        this.openPayrollSetting();
      }

      this.$store.showCompanySetting = "";
    }
    if (this.$route.query.sec == "company") {
      this.openCompanySetting();
    }
  },
  updated() {
    if (this.$route.query.sec === "company") {
      this.openCompanySetting();

      this.$nextTick(() => {
        const targetElement = document.getElementById("departments");

        if (targetElement) {
          targetElement.scrollIntoView({ block: "start", behavior: "smooth" });
        
        }
      });
    }
  },
  created() {
    this.getManagerLevel();
  },
};
</script>

<style lang="scss" scoped>
.f_content {
  @media (max-width: 768px) {
     width: 90vw;
  overflow: scroll;
  }
 
}
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;


  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }


  .content {
    margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;
    overflow: scroll;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.setting {
  padding-top: 4rem;
  padding-left: 3.125rem;
  padding-right: 3.125rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }

  > p {
    text-align: left;
    font-size: 2rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .setting__div {
    border-top: 1px solid #caced5;
  }
}

.setting__nav {
  margin-top: 40px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  border-bottom: 1px solid #caced5;

  > .setting__nav--item {
    float: left;
    width: 25%;
    font-size: 1rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    padding-bottom: 20px;
    cursor: pointer;

    @media (max-width: 768px) {
      padding: 0;
    font-size: 0.8rem;
      width: 4rem;
      margin-right: 2rem;
    }
  }
}
</style>